import React, { useEffect, useState } from 'react'
import { AgruparByProp } from '../../../../Helpers/Agrupaciones/AgruparByProp';
import { ArrayTotalizarByProp } from '../../Actions/TotalizarProps';
import { GetKey } from '../../Actions/GetContainer';
import request from '../../../../Helpers/API';
// import { useBox, useLoading } from '../../../../hooks/useForm';
// import { useLoading } from './useLoading';
import { useBox } from '../../Helper/useBox';
import { LoaderScreen } from '../../../components/LoaderScreen';
import { BoxStructure } from './BoxSctructure';
import { FormatMoney } from '../../../../Helpers/FormatNumber';
import { SelectArray } from './SelectArray';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory, useLocation } from "react-router-dom";
import PlantillaScreen from '../../../helpers/PlantillaScreen';

export default function AntiguedadInventarioScreen() {
    const [boxstate, setBoxState, updateBoxState] = useBox();
    const history = useHistory();
    const [primeraVez, setPrimeraVez] = useState(true);
    const location = useLocation();
    const permisos = location.state;
    const idSucursalUnicos = [
        ...new Map(permisos.map(item => [item.idsucursal, { idsucursal: item.idsucursal }])).values()
    ];
    // const [loading, stratloading, changeloading] = useLoading();
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [linea, setlinea] = useState('CONSOLIDADO')
    const [familia, setFamilia] = useState('CONSOLIDADO')
    const [antiguedad, setAntiguedad] = useState('CONSOLIDADO');

    const onHome = () => {
        history.push("/Finanzas/Main");
    };

    const [state, setState] = useState({
        data: [],
        info: [],
        lineas: [],
        stfamilia: [],
        costo: 0,
        dias: 0,
        mes: 0
    })

    useEffect(() => {
        BoxClick();
    }, []);

    useEffect(() => {
        setPrimeraVez(false);
    }, []);

    const BoxClick = () => {
        setLoader({ ...loader, mostrar: true });
        return new Promise((res, req) => {
            const post = {
                adr: GetKey(boxstate.pv.adr, ['idadr']),
                sucursales: GetKey(boxstate.pv.sucursal, ["idsucursal"]),
                linea,
                antiguedad,
                grupo: familia,
                arraysucursales: boxstate.titulosucursal
            };
            request.post('FEInventarioAntiguedad/ObtenerInventario', post)
                .then(result => {
                    setLoader({ ...loader, mostrar: false });
                    // console.log(result)
                    setState({
                        ...state,
                        data: result.invAntiguedad,
                        info: result.invAntiguedadInfo
                    })
                    res('')
                }).catch(err => {
                    setLoader({ ...loader, mostrar: false });
                    req(JSON.stringify(err))
                })
        })
    }
    useEffect(() => {

        var array = AgruparByProp(state.data, 'familia');
        var newarray = []
        if (array !== undefined && array != null && array.length > 0) {
            array.forEach(item => {
                var obj = {
                    display: item,
                    costo: 0,
                    dias: 0,
                    antiguedad: 0,
                    data: []
                }
                var arraydesc = state.data.filter(x => x.familia === item)
                    .sort((a, b) => b.antiguedaddias - a.antiguedaddias);
                var dias = FormatMoney(ArrayTotalizarByProp(arraydesc, 'antiguedaddias') / arraydesc.length, 0);
                var mes = FormatMoney(ArrayTotalizarByProp(arraydesc, 'nummonth') / arraydesc.length, 0);
                var costo = FormatMoney(ArrayTotalizarByProp(arraydesc, 'costo'), 0);
                obj.costo = costo;
                obj.dias = dias;
                obj.mes = mes;
                obj.data = arraydesc;

                newarray = [...newarray, obj]
            })
        }

        var dias = FormatMoney(ArrayTotalizarByProp(state.data, 'antiguedaddias') / state.data.length, 0);
        var mes = FormatMoney(ArrayTotalizarByProp(state.data, 'nummonth') / state.data.length, 0);
        setState({
            ...state,
            stfamilia: newarray,
            costo: FormatMoney(ArrayTotalizarByProp(state.data, 'costo'), 0),
            dias,
            mes
        })

    }, [state.data])
    const imprimirexcel = () => {
        setLoader({ ...loader, mostrar: true });
        const post = {
            adr: GetKey(boxstate.pv.adr, ['idadr']),
            sucursales: GetKey(boxstate.pv.sucursal, ['idsucursal']),
            linea,
            antiguedad,
            grupo: familia,
            arraysucursales: boxstate.titulosucursal
        };
        request.post('FEInventarioAntiguedad/GenerarExcel', post)
            .then(({ documento, filename }) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${filename}.xlsx`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                // stratloading(false);
            }).catch(err => {
                setLoader({ ...loader, mostrar: false });
                // changeloading(JSON.stringify(err), false)
            })
    }

    const arraylineas = [
        { id: 'CONSOLIDADO', descripcion: 'Consolidado' },
        { id: 'MQ', descripcion: 'Maquinaria' },
        { id: 'MA', descripcion: 'P. Aliados' },
        { id: 'UM', descripcion: 'Seminuevos' },
        { id: 'MW', descripcion: 'Riego' },
        { id: 'SC', descripcion: 'Otros' }
    ]
    const arrayantiguedad = [
        { id: 'CONSOLIDADO', descripcion: 'Consolidado' },
        { id: 'D0A3', descripcion: 'De 0 a 3 meses' },
        { id: 'D3A6', descripcion: 'De 3 a 6 meses' },
        { id: 'M6', descripcion: 'Mas de 6 meses' }
    ]


    const arrayconcepto = [
        { id: 'CONSOLIDADO', descripcion: 'Consolidado' },
        { id: 'TRILLADORAS O COMBINADAS', descripcion: 'Trilladoras o combinadas' },
        { id: 'TRACTORES', descripcion: 'Tractores' },
        { id: 'IMPLEMENTOS', descripcion: 'Implementos' },
        { id: 'EQUIPO JARDINERO', descripcion: 'Equipo jardinero' },
        { id: 'AMS', descripcion: 'AMS' }
    ]
    const clase = (antiguedad) => {
        switch (antiguedad) {
            case 'D0A3': return 'ant-crr';
            case 'D3A6': return 'ant-adv';
            default: return 'ant-red';
        }
    }
    // console.log(permisos)
    return (
        <PlantillaScreen
            titulo={`ANTIGUEDAD DE INVENTARIO`}
            className={"antiguedad-inventario-main-screen"}
            className_main={1}
        >
            <div className="antiguedad-inventario">
                <LoaderScreen loader={loader} />
                <div className="antiguedad-inventario-contenedor-filtros">
                    <div className="antiguedad-inventario-regresar" onClick={() => onHome()}>
                        <ArrowBackIcon /> Regresar
                    </div>
                    {/* <Loading lanzar={loading.lanzar} mensaje={loading.mensaje} error={loading.error} start={stratloading} /> */}
                    <BoxStructure
                        onBoxChange={setBoxState}
                        boxState={boxstate}
                        BoxClick={BoxClick}
                        updateBoxState={updateBoxState}
                        dmesfin="none"
                        dmesinicio='none'
                        dejercicio='none'
                        cargarDepartamento={false}
                        titulo_filtro='FILTRO'
                        sucursales={permisos}
                        mostrartodassucursales={true}
                    // subtitulo={state.info.usuario === undefined || state.info.usuario === null ? ''
                    //     : `Cargado el ${state.info.fecha}`}
                    // usuariodefault={1}
                    >
                        <div key='box-filtro'>
                            <div className="filtro-group">
                                <label>Linea</label>
                                <SelectArray
                                    data={arraylineas}
                                    propid='id'
                                    value={linea}
                                    propdescripcion='descripcion'
                                    onChange={({ target }) => {
                                        setlinea(target.value);
                                        setFamilia('Consolidado');
                                    }}
                                />
                            </div>
                            {
                                linea !== 'MQ'
                                    ? <></>
                                    : <div className='filtro-group'>
                                        <label>Grupo</label>
                                        <SelectArray
                                            data={arrayconcepto}
                                            propid='id'
                                            value={familia}
                                            propdescripcion='descripcion'
                                            onChange={({ target }) => { setFamilia(target.value) }}
                                        />
                                    </div>
                            }
                            <div className="filtro-group">
                                <label>Antiguedad</label>
                                <SelectArray
                                    data={arrayantiguedad}
                                    propid='id'
                                    value={antiguedad}
                                    propdescripcion='descripcion'
                                    onChange={({ target }) => { setAntiguedad(target.value) }}
                                />
                            </div>

                        </div>
                        <div key='box-actions'>
                            <button className='button-excel' onClick={imprimirexcel}>Excel</button>
                        </div>
                    </BoxStructure>
                </div>
                {state.data === undefined || state.data === null || state.data.length === 0
                    ? <div>Sin datos para mostrar</div>
                    : <div className='container-inv'>
                        <div className='main scroll'>
                            <table cellSpacing={0}>
                                <tbody>
                                    {state.stfamilia.map((f, index) => (
                                        <>
                                            <tr className='tr-familia'>
                                                <td colSpan={8}>{f.display}</td>
                                            </tr>
                                            <tr className='tr-encabezado' style={{ display: index === 0 ? '' : 'none' }}>
                                                <td>Sucursal</td>
                                                <td>Linea</td>
                                                <td>Modelo</td>
                                                <td>Descripción</td>
                                                <td>Num. Economico</td>
                                                <td>Antiguedad Dias</td>
                                                <td>Antiguedad Meses</td>
                                                <td>Costo</td>
                                            </tr>
                                            {
                                                f.data.map(x => (
                                                    <tr className='tr-detalle'>
                                                        <td>{x.sucursal}</td>
                                                        <td>{x.descfamilia}</td>
                                                        <td>{x.modelo}</td>
                                                        <td>{x.nombremodelo}</td>
                                                        <td>{x.neconomico}</td>
                                                        <td className={clase(x.antiguedadmes)}>{x.antiguedaddias}</td>
                                                        <td className={clase(x.antiguedadmes)}>{x.nummonth}</td>
                                                        <td className={clase(x.antiguedadmes)}>{FormatMoney(x.costo, 0)}</td>
                                                    </tr>
                                                ))
                                            }
                                            <tr className='tr-total-familia'>
                                                <td colSpan={5}>{f.display}</td>
                                                <td>{f.dias}</td>
                                                <td>{f.mes}</td>
                                                <td>{f.costo}</td>
                                            </tr>

                                            <tr style={{ height: 50 }}></tr>
                                        </>
                                    ))}
                                    <tr className='tr-total-grupo'>
                                        <td colSpan={5}>TOTAL INVENTARIO</td>
                                        <td>{state.dias}</td>
                                        <td>{state.mes}</td>
                                        <td>{state.costo} </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                }
            </div >
        </PlantillaScreen>
    )
}
